import { HttpMethod } from '../methods';
import { UrlConstant } from '../../Core/Interfaces/interfaces';

export const GET_USER_SESSIONS: UrlConstant = { path: '/sessions/getUserSessions', method: HttpMethod.GET };
export const GET_SESSION: UrlConstant = { path: '/sessions/session/:sessionId', method: HttpMethod.GET };
export const POST_MEETING_INSTANCE_OPTIONS: UrlConstant = { path: '/sessions/meeting-instance/options', method: HttpMethod.POST };
export const POST_MEETING_INSTANCE_REQUEST_CAPTIONS: UrlConstant = { path: '/sessions/meeting-instance/requestCaptions', method: HttpMethod.POST };
export const POST_MEETING_INSTANCE_ALLOW_CAPTIONS: UrlConstant = { path: '/sessions/meeting-instance/allowCaptions', method: HttpMethod.POST };
